import React, { useEffect, useState } from "react";
import { Col, Row, Card, CardBody, Button, Table, Container } from 'reactstrap';
import { reduxForm } from 'redux-form';
import ThirdsApi from '../api/thirds_api';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import Spinner from 'react-bootstrap/Spinner';
import ReportsApi from '../api/reports_api';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFilePdf, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import Modal from '@material-ui/core/Modal';
import ClosuresOfCashReceiptsPDF from '../exports/pdf/ClosuresOfCashReceiptsPDF';
import OperationsDiaryPDF from '../exports/pdf/OperationsDiaryPDF';
import PatientsSeenByDiagnosist from '../exports/excel/PatientsAtendedDiagnostic';
import FallingRisk from "../exports/excel/FallingRisk";
import ClosuresOfCashReceiptsExcel from '../exports/excel/ClosuresOfCashReceiptsExcel';
import CauseOfMorbidity from './CauseOfMorbidity/CauseOfMorbidity';
import DetailedSurcharges from './DetailedSurcharges/DetailedSurcharges';
import FornMNMPReportExcel from '../exports/excel/FormNMPReport';
import FormNMPReport from "../exports/excel/FormNMPReport";
import ClosuresOfCashReceiptsPDFAccountant from "../exports/pdf/ClosuresOfCashReceiptsPDFAccountant";
import DiaryAgendaServicesByProfReportPDF from "../exports/pdf/DiaryAgendaServicesByProfReportPDF";
import ClosuresOfCashReceiptsExcelWithInvoice from "../exports/excel/ClosuresOfCashReceiptsExcelWithInvoice";
import Checkbox from '@material-ui/core/Checkbox';
import { withStyles } from "@material-ui/core/styles";
import { FormControlLabel } from "@material-ui/core";

const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ReportsForm = ({ history, location }) => {
    //Filters
    const [starterDate, setStarterDate] = useState(null);
    const [finalDate, setFinalDate] = useState(null);
    const [thirds, setThirds] = useState([]);
    const [thirdSelected, setThirdSelected] = useState(0);
    const [contractsThird, setContractsThird] = useState([]);
    const [contract, setContract] = useState(null);
    const [thridPlusContract, setThridPlusContract] = useState([]);
    const [wholeThird, setWholeThird] = useState(null);
    const [idContract, setIdContract] = useState(0);

    //Results
    const [Reports, setReports] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showPDF, setShowPDF] = useState(false);

    //Modal Causa Morbilidad
    const [causeOfMorbidity, setCauseOfMorbidity] = useState(false);
    const [causeOfMorbidityData, setCauseOfMorbidityData] = useState([]);

    //Modal Detalles Recargos
    const [detailsSurchargesModal, setDetailsSurchargesModal] = useState(false);
    const [detailsSurchargesData, setDetailsSurchargesData] = useState([]);

    const [checkClassifyServices, setCheckClassifyServices] = useState(false);

    useEffect(() => {
        handleChangeFilters(true);
        findThirdsForReports();
    }, []);

    const findThirdsForReports = async () => {
        let thirdsList = await ThirdsApi.listThirdsReports();
        setThirds(thirdsList);
        let thirdsPlusContract = await ThirdsApi.loadThirdPlusContract();
        setThridPlusContract(thirdsPlusContract);
    }

    const handleChangeThird = async (value) => {
        await setThirdSelected(value);
        await handleChangeFilters(false);
    }

    const handleChangeThirdPlusContract = async (third) => {
        await setWholeThird(third);
        await handleChangeFilters(false);
        setThirdSelected(third.id_tercero);
        setIdContract(parseInt(third.id_contrato));
    }

    const handleChangeStarterDate = async (value) => {
        await setStarterDate(value);
        await handleChangeFilters(false);
    }

    const handleChangeFinalDate = async (value) => {
        await setFinalDate(value);
        await handleChangeFilters(false);
    }

    const handleChangeFilters = async (starter) => {
        try {
            setIsLoading(true);
            let Reportes = [
                { tipo: 1, nombre: "Reporte Cierre de Recibos de Caja (PDF)" },
                { tipo: 2, nombre: "Reporte de Pacientes Atendidos por Diagnostico" },
                { tipo: 4, nombre: "Diario de Operaciones" },
                { tipo: 5, nombre: "Reporte Cierre de Recibos de Caja (Excel)" },
                { tipo: 6, nombre: "Causa de Morbilidad" },
                { tipo: 7, nombre: "Detallado de Recargos" },
                { tipo: 8, nombre: "Planilla MNP" },
                { tipo: 9, nombre: "Reporte Cierre de Recibos de Caja (Contador) PDF" },
                { tipo: 10, nombre: "Agenda diaria según servicios prestados por profesional" },
                { tipo: 11, nombre: "Cierre de Facturación" }
            ]

            var user = JSON.parse(sessionStorage.getItem('usuario'));
            if (user !== null) {
                if (user.perfil != undefined) {
                    var modulos = user.perfil.modulos;
                    if (modulos.includes(27)) {
                        setReports(Reportes);
                    }
                    else if (modulos.includes(36)) //Tecnologo
                    {
                        setReports(Reportes.filter(rep => rep.tipo == 4));
                    }
                    else {
                        setReports([]);
                    }
                }
                else {
                    setReports(Reportes);
                }
            } else {
                setReports([]);
            }
            setIsLoading(false);
        }
        catch (err) {
            console.log(err);
        }
    }

    const handleChangeContractThird = (contract) => {
        setContract(contract)
    }

    const exportReport = async (opt) => {
        setIsLoading(true);
        switch (opt) {
            case 1: //Cierre de Recibos de Caja (PDF)
                await reporteCierresRecibosCaja("pdf", "normal").then(result => {
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
                break;
            case 2: //Reporte de Pacientes por Diagnostico
                await reportePacientesAtendidosPorDiagnostico().then(result => {
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
                break;
            case 4: //Diario de Operaciones
                await reportOperationsDiary().then(result => {
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
                break;
            case 5: //Cierre de Recibos de Caja (Excel)
                await reporteCierresRecibosCaja("excel", "normal").then(result => {
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
                break;

            case 6: //Causa de Morbilidad
                if (starterDate != null && finalDate != null) {
                    await ReportsApi.loadCauseOfMorbidity(starterDate, finalDate).then(data => {
                        setCauseOfMorbidityData(data);
                        setIsLoading(false);
                        setCauseOfMorbidity(true);
                    }).catch((err) => {
                        setCauseOfMorbidityData([]);
                        setIsLoading(false);
                    });
                }
                else {
                    setIsLoading(false);
                    alert("La fecha inicial y fecha final son obligatorias");
                }

                break;

            case 7: //Detallado de Recargos
                if (starterDate != null && finalDate != null) {
                    console.log("data");
                    await ReportsApi.loadDetailedSurcharges(starterDate, finalDate, null).then(data => {
                        setDetailsSurchargesData(data);
                        setDetailsSurchargesModal(true);
                        setIsLoading(false);
                    }).catch((err) => {
                        setDetailsSurchargesData([]);
                        setDetailsSurchargesModal(false);
                        console.log(err);
                        setIsLoading(false);
                    });
                }
                else {
                    setIsLoading(false);
                    alert("La fecha inicial y fecha final son obligatorias");
                }

                break;
            case 8: //Planilla MNP
                if (starterDate != null && finalDate != null) {
                    setIsLoading(true);
                    await ReportsApi.loadFormMNPReport(starterDate, finalDate, thirdSelected, idContract).then(data => {
                        setIsLoading(false);
                        if (!!data.length) {
                            FormNMPReport.exportExcel(data);
                        } else {
                            alert('No hay suficientes datos para generar el reporte')
                        }
                    }).catch((err) => {
                        console.log(err);
                        setIsLoading(false);
                    });
                }
                else {
                    setIsLoading(false);
                    alert("La fecha inicial y fecha final son obligatorias");
                }
                break;
            case 9: //Cierre de Recibos de Caja (PDF) Contador
                await reporteCierresRecibosCajaCero("pdf").then(result => {
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
                break;
            case 10: //Agenda diaria segun servicios prestados por profesional
                await reportAmountOfAppontmentsByProfessional().then(result => {
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
                break;
            case 11: //Recibos caja facturados
                await billingReport().then(result => {
                    setIsLoading(false)
                }).catch(err => {
                    console.log(err);
                    setIsLoading(false);
                });
                break;

            default:
                setIsLoading(false);
                break;
        }
        return;
    }

    //------- Report de Cierre de Recibos de Caja -------//
    const reporteCierresRecibosCaja = async (file, type) => {
        console.log("FILE", file);
        let filtroReport = null;
        if (starterDate == null) {
            alert("Debe seleccionar la Fecha Inicial");
            return;
        }
        if (finalDate == null) {
            alert("Debe seleccionar la Fecha Final");
            return;
        }

        let ReportCierre = [];
        let admissionsWithoutRecipts = [];

        let fInicial = moment(starterDate).format("YYYY/MM/DD");
        let fFinal = moment(finalDate).format("YYYY/MM/DD");

        if (thirdSelected != 0 && starterDate != null && finalDate != null) { //Con tercero seleccionado
            filtroReport = {
                "fecha_inicio": moment(fInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                "fecha_final": moment(fFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                "id_tercero": thirdSelected,
                "id_contrato": idContract
            }
            ReportCierre = await ReportsApi.listClosuresOfCashReceipts(filtroReport);
            admissionsWithoutRecipts = await ReportsApi.listParticularAdmissionsWithoutReceipt(filtroReport);
            if (ReportCierre.reporte != null) {
                console.log("REPORTREICPT", ReportCierre, 'type', type)
                if (file == "pdf" && type === "normal") {
                    await ClosuresOfCashReceiptsPDF.exportPDF(ReportCierre.reporte, starterDate, finalDate);
                }
                if (file == "excel" && type === "normal") {
                    ClosuresOfCashReceiptsExcel.exportExcel(ReportCierre.reporte, starterDate, finalDate);
                }
                if (file == "pdf" && type === "contador" && newReciptsWithoutTotalZero.length > 0) {
                    await ClosuresOfCashReceiptsPDFAccountant.exportPDFAccountant(ReportCierre.reporte, starterDate, finalDate, admissionsWithoutRecipts.reporte);
                }
                if (file == "excel" && type === "recibos_fac") {
                    let justReciptsWithInvoice = ReportCierre.reporte.recibos_caja.filter((receipts) => receipts.estado === 2 && receipts.recibo_cancelado !== true);
                    if (!!justReciptsWithInvoice.length) {
                        ClosuresOfCashReceiptsExcelWithInvoice.exportExcel(justReciptsWithInvoice, starterDate, finalDate);
                    } else {
                        alert("No se encontraron datos para generar este reporte");
                    }
                }
            }
            else {
                alert("No se encontraron datos para generar este PDF");
            }
        }
        else if (starterDate != null && finalDate != null) {//Sin tercero Seleccionado
            filtroReport = {
                "fecha_inicio": moment(fInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                "fecha_final": moment(fFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                "id_tercero": null
            }
            ReportCierre = await ReportsApi.listClosuresOfCashReceipts(filtroReport);
            admissionsWithoutRecipts = await ReportsApi.listParticularAdmissionsWithoutReceipt(filtroReport);
            if (ReportCierre.reporte != null) {
                let newReciptsWithoutTotalZero = ReportCierre.reporte.recibos_caja.filter(receipt => parseInt(receipt.total) !== 0);
                console.log("REPORTREICPT", ReportCierre, 'admissionsWithoutRecipts', admissionsWithoutRecipts, "newReciptsWithoutTotalZero", newReciptsWithoutTotalZero)
                if (file == "pdf" && type === "normal") {
                    await ClosuresOfCashReceiptsPDF.exportPDF(ReportCierre.reporte, starterDate, finalDate);
                }
                if (file == "excel" && type === "normal") {
                    ClosuresOfCashReceiptsExcel.exportExcel(ReportCierre.reporte, starterDate, finalDate);
                }
                if (file == "pdf" && type === "contador" && newReciptsWithoutTotalZero.length > 0) {
                    await ClosuresOfCashReceiptsPDFAccountant.exportPDFAccountant(ReportCierre.reporte, starterDate, finalDate, admissionsWithoutRecipts.reporte);
                }
                if (file == "excel" && type === "recibos_fac") {
                    let justReciptsWithInvoice = ReportCierre.reporte.recibos_caja.filter((receipts) => receipts.estado === 2 && receipts.recibo_cancelado !== true);
                    if (!!justReciptsWithInvoice.length) {
                        ClosuresOfCashReceiptsExcelWithInvoice.exportExcel(justReciptsWithInvoice, starterDate, finalDate);
                    } else {
                        alert("No se encontraron datos para generar este reporte");
                    }
                }
            }
            else {
                alert("No se encontraron datos para generar este PDF");
            }
        }
    }

    //------- Report de Cierre de Recibos de Caja cero-------//
    const reporteCierresRecibosCajaCero = async (file) => {
        console.log("FILE", file);
        let filtroReport = null;
        if (starterDate == null) {
            alert("Debe seleccionar la Fecha Inicial");
            return;
        }
        if (finalDate == null) {
            alert("Debe seleccionar la Fecha Final");
            return;
        }

        let ReportCierre = [];
        let admissionsWithoutRecipts = [];

        let fInicial = moment(starterDate).format("YYYY/MM/DD");
        let fFinal = moment(finalDate).format("YYYY/MM/DD");

        if (thirdSelected != 0 && starterDate != null && finalDate != null) { //Con tercero seleccionado
            filtroReport = {
                "fecha_inicio": moment(fInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                "fecha_final": moment(fFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                "id_tercero": thirdSelected,
                "id_contrato": idContract,
                "mayor_cero": true
            }
            ReportCierre = await ReportsApi.listClosuresOfCashReceiptsZero(filtroReport);
            admissionsWithoutRecipts = await ReportsApi.listParticularAdmissionsWithoutReceipt(filtroReport);
            if (ReportCierre.reporte != null) {
                console.log("REPORTREICPT", ReportCierre)
                if (file == "pdf") {
                    await ClosuresOfCashReceiptsPDFAccountant.exportPDFAccountant(ReportCierre.reporte, starterDate, finalDate, admissionsWithoutRecipts.reporte);
                }
            }
            else {
                alert("No se encontraron datos para generar este PDF");
            }
        }
        else if (starterDate != null && finalDate != null) {//Sin tercero Seleccionado
            filtroReport = {
                "fecha_inicio": moment(fInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                "fecha_final": moment(fFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                "id_tercero": null,
                "mayor_cero": true
            }
            ReportCierre = await ReportsApi.listClosuresOfCashReceiptsZero(filtroReport);
            admissionsWithoutRecipts = await ReportsApi.listParticularAdmissionsWithoutReceipt(filtroReport);
            if (ReportCierre.reporte != null) {
                console.log("REPORTREICPT", ReportCierre, 'admissionsWithoutRecipts', admissionsWithoutRecipts)
                if (file == "pdf") {
                    await ClosuresOfCashReceiptsPDFAccountant.exportPDFAccountant(ReportCierre.reporte, starterDate, finalDate, admissionsWithoutRecipts.reporte);
                }
            }
            else {
                alert("No se encontraron datos para generar este PDF");
            }
        }
    }

    //------- Pacientes Atendidos por Diagnostico -------// 
    const reportePacientesAtendidosPorDiagnostico = async () => {
        let filtroReport = null;
        if (starterDate == null) {
            alert("Debe seleccionar la Fecha Inicial");
            return;
        }
        if (finalDate == null) {
            alert("Debe seleccionar la Fecha Final");
            return;
        }

        let ReportPacientsDiagnostic = [];
        filtroReport = {
            "fecha_inicio": moment(starterDate).format('YYYY/MM/DD'),
            "fecha_final": moment(finalDate).format('YYYY/MM/DD'),
            "id_tercero": thirdSelected,
            "id_contrato": idContract
        }
        ReportPacientsDiagnostic = await ReportsApi.listPatientsForDiagnostic(filtroReport);
        console.log("EXCELDiagnostico", ReportPacientsDiagnostic)
        if (ReportPacientsDiagnostic.reporte != null) {
            await PatientsSeenByDiagnosist.exportExcel(ReportPacientsDiagnostic.reporte, starterDate, finalDate);
        }
        else {
            alert("No se encontraron datos para generar este EXCEL");
        }
    }

    const reportAmountOfAppontmentsByProfessional = async () => {
        let report = [];
        let filtroReport = null;
        if (starterDate == null) {
            alert("Debe seleccionar la Fecha Inicial");
            return;
        }
        if (finalDate == null) {
            alert("Debe seleccionar la Fecha Final");
            return;
        }
        let fInicial = moment(starterDate).format("YYYY/MM/DD");
        let fFinal = moment(finalDate).format("YYYY/MM/DD");
        filtroReport = {
            "fecha_inicio": moment(fInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            "fecha_final": moment(fFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            "id_tercero": thirdSelected,
            "id_contrato": idContract
        }
        report = await ReportsApi.amountOfAppointmentsByProfessional(filtroReport)

        if (!!report) {
            if (!!report.length) {
                let dataToSend = {
                    profile: JSON.parse(sessionStorage.getItem('clinica')),
                    reporte: report,
                    title: 'Resumen de Agenda Medica',
                    fInicial,
                    fFinal,
                    classifyServices: checkClassifyServices
                }
                DiaryAgendaServicesByProfReportPDF(dataToSend);
            } else {
                alert("No se encontraron datos para generar el archivo");
            }
        } else {
            alert("No se encontraron datos para generar el archivo");
        }
    }

    const reportOperationsDiary = async () => {
        let filtroReport = null;
        if (starterDate == null) {
            alert("Debe seleccionar la Fecha Inicial");
            return;
        }
        if (finalDate == null) {
            alert("Debe seleccionar la Fecha Final");
            return;
        }

        let ReportOperationDiary = [];
        let fechaInicial = moment(starterDate).format('YYYY/MM/DD');
        let fechaFinal = moment(finalDate).format('YYYY/MM/DD');

        filtroReport = {
            "fecha_inicio": moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            "fecha_final": moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            "id_tercero": thirdSelected != 0 && thirdSelected != null ? thirdSelected : null,
            "id_contrato": idContract != 0 && idContract != null ? idContract : null
        }
        ReportOperationDiary = await ReportsApi.operationsDiaryReport(filtroReport);
        if (ReportOperationDiary.length > 0) {
            let clinica = JSON.parse(sessionStorage.getItem('clinica'));
            let obj = {
                items: ReportOperationDiary,
                profile: clinica,
                title: "Diario de Operaciones",
                starterDate: fechaInicial,
                finalDate: fechaFinal
            }
            setShowPDF(true);
            await OperationsDiaryPDF(obj);
        }
        else {
            alert("No se encontraron datos para generar este Reporte");
        }
        return ReportOperationDiary;
    }

    const billingReport = async () => {
        let filtroReport = null;
        if(wholeThird == null){
            alert("Debe seleccionar Cliente + Contrato");
            return;
        }
        if (starterDate == null) {
            alert("Debe seleccionar la Fecha Inicial");
            return;
        }
        if (finalDate == null) {
            alert("Debe seleccionar la Fecha Final");
            return;
        }

        let fechaInicial = moment(starterDate).format('YYYY/MM/DD');
        let fechaFinal = moment(finalDate).format('YYYY/MM/DD');

        filtroReport = {
            "fecha_inicio": moment(fechaInicial + " " + "00:00:00").format('YYYY-MM-DD HH:mm:ss'),
            "fecha_final": moment(fechaFinal + " " + "23:59:59").format('YYYY-MM-DD HH:mm:ss'),
            "id_tercero": thirdSelected        }
        let billingReport = await ReportsApi.blligReportDates(filtroReport);
        if (billingReport.length > 0) {
            console.log("billingReport", billingReport)
            //setShowPDF(true);
            ClosuresOfCashReceiptsExcelWithInvoice.exportExcel(billingReport, starterDate, finalDate);
        }
        else {
            alert("No se encontraron datos para generar este Reporte");
        }
    }

    const listPlans = async (id_third) => {
        await ThirdsApi.getContracts(id_third).then((res) => {
            console.log("RESPONSE", res)
            setContractsThird(res);
        })
            .catch((error) => {
                console.log(error);
            })
        console.log("STATECONT", contractsThird)
    }

    return (
        <Card>
            <CardBody>
                <Row>
                    <Col md={12}>
                        <div className="card__title">
                            <h5 className="bold-text">Filtros</h5>
                        </div>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={4}>
                        <TextField
                            id="select_third"
                            select
                            label="Cliente + Contrato"
                            value={wholeThird}
                            className='medical-material-form__field'
                            onChange={(event) => {
                                handleChangeThirdPlusContract(event.target.value);
                                //listPlans(event.target.value);
                            }}

                            style={{ minWidth: '300px', maxWidth: '100%' }}
                        >
                            <MenuItem selected={true} key={0} value={0}>
                                Sin Tercero                                </MenuItem>
                            {thridPlusContract.map((third, index) => {
                                return <MenuItem key={index} value={third}>
                                    {third.nombre_tercero_concatenado}
                                </MenuItem>
                            })}
                        </TextField>
                        <br /><br />
                    </Col>
                    <Col md={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <KeyboardDatePicker
                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                value={starterDate}
                                onChange={(date) => {
                                    handleChangeStarterDate(date);
                                }}
                                label="Fecha Inicial"
                                format="yyyy/MM/DD"
                                animateYearScrolling
                                className='medical-material-form__field material-form__label'
                                autoOk={true}
                                disableFuture
                            />
                        </MuiPickersUtilsProvider>
                        <br /><br />
                    </Col>
                    <Col md={4}>
                        <MuiPickersUtilsProvider utils={MomentUtils} >
                            <KeyboardDatePicker
                                style={{ minWidth: '300px', maxWidth: '100%' }}
                                value={finalDate}
                                onChange={(date) => {
                                    handleChangeFinalDate(date);
                                }}
                                label="Fecha Final"
                                format="yyyy/MM/DD"
                                animateYearScrolling
                                className='medical-material-form__field material-form__label'
                                autoOk={true}
                                disableFuture
                            />
                        </MuiPickersUtilsProvider>
                        <br /><br />
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col md={12}>
                        {isLoading && <Spinner animation="border" variant="success" />}
                        {Reports.length > 0 && (
                            <Container>
                                <Row className="container-list-reports">
                                    {Reports.map(elem => (
                                        <Col sm={12} md={4} className='element-report'>
                                            <div>
                                                <FontAwesomeIcon
                                                    className={
                                                        //PDF
                                                        elem.tipo == 1 || elem.tipo == 4 || elem.tipo == 9 || elem.tipo == 10
                                                            ? "text-danger" :
                                                            //Excel
                                                            elem.tipo == 2 ||
                                                                elem.tipo == 3 || elem.tipo == 5 || elem.tipo == 8 || elem.tipo == 11
                                                                ? "text-success" :
                                                                elem.tipo == 6 || elem.tipo == 7 ? "text-secondary" : null
                                                    }
                                                    style={{ fontSize: '20px' }}
                                                    icon={
                                                        //Pdf
                                                        elem.tipo == 1 || elem.tipo == 4 || elem.tipo == 9 || elem.tipo == 10
                                                            ? faFilePdf :
                                                            //Excel
                                                            elem.tipo == 2 ||
                                                                elem.tipo == 3 || elem.tipo == 5 || elem.tipo == 8 || elem.tipo == 11
                                                                ? faFileExcel :
                                                                elem.tipo == 6 || elem.tipo == 7 ? faFileAlt :
                                                                    null
                                                    }
                                                />
                                                <a href="#" onClick={() => exportReport(elem.tipo)}>
                                                    {elem.nombre}
                                                </a>
                                            </div>
                                            {elem.tipo === 10 ?
                                                <div>
                                                    <FormControlLabel
                                                        control={
                                                            <MedicalCheckbox
                                                                color="default"
                                                                onChange={(e, checked) => {
                                                                    setCheckClassifyServices(checked);
                                                                }}
                                                                checked={checkClassifyServices}
                                                            />
                                                        }
                                                        label="Clasificar por tipo de Servicio"
                                                    />
                                                </div>
                                                : null}
                                        </Col>
                                    ))}
                                </Row>
                            </Container>
                        )}
                    </Col>
                </Row>

                {showPDF ?
                    <Modal
                        open={showPDF}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                        style={{ zIndex: 1000 }}
                    >
                        <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                            <IconButton style={{ float: 'right' }} onClick={() => {
                                setShowPDF(false);
                            }}>
                                <CloseIcon />
                            </IconButton>

                            <iframe id="pdfV" width="1000" height="700" >
                            </iframe>
                        </div>
                    </Modal>
                    : null}

                <CauseOfMorbidity
                    opened={causeOfMorbidity}
                    closeModal={() => setCauseOfMorbidity(false)}
                    data={causeOfMorbidityData} />

                <DetailedSurcharges
                    opened={detailsSurchargesModal}
                    closeModal={() => setDetailsSurchargesModal(false)}
                    data={detailsSurchargesData}
                />

            </CardBody>
        </Card>
    );
}

export default reduxForm({
    form: 'horizontal_form_reports',
})(ReportsForm);